var codeblock_default = {
  "blockStyleSpacing": "yO1EJ",
  "codeBlock": "hjArN yO1EJ",
  "renderedInTable": "_79ci-"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
